$(document).ready(function (ready) {

    //REGISTRATION
    if ($('form#create_customer').length) {
        let userEmail,
            userName,
            userLastName;

        $(document).on('submit', 'form#create_customer', function (evt) {
            const form = $(this);
            userEmail = form.find('input[name="customer[email]"]').val();
            userName = form.find('input[name="customer[first_name]"]').val();
            userLastName = form.find('input[name="customer[last_name]"]').val();

            if (!userEmail || !userName || !userLastName) {
                return false
            }

            let formData = {
                "contact": {
                    "channels": [
                        {
                            "type": "email",
                            "value": `${userEmail}`
                        }

                    ],
                    "firstName": `${userName}`,
                    "lastName": `${userLastName}`,
                },
                "formType": "createUser"
            };

            let formattedFormData = JSON.stringify(formData);

            localStorage.setItem('new_user_data', formattedFormData);

        })



    }

    if (/new_user=success/.test(window.location.href)) {
        const userData = localStorage.getItem('new_user_data')
        const settings = {
            async: true,
            crossDomain: true,
            url: 'https://esputnik.com/api/v1/contact/subscribe',
            method: 'POST',
            headers: {
                accept: 'application/json; charset=UTF-8',
                'content-type': 'application/json',
                authorization: 'Basic YXJ0aXN0cHVzaG5ldEBnbWFpbC5jb206d2V0cjQ1R3J2amRoNTRlNQ=='
            },
            processData: false,
            data: userData
        };



        $.ajax(settings).done(function (response) {
        console.log(response);
        });
    }

    //EDIT CUSTOMER DATA

    //Addresses page
    if ( $('.addresses-list').length ) {

        const emailFieldVal = $('.profile-block .customer-email').find('input[type="email"]').val();

            $(document).on('submit', '.profile-block form', function (evt) {
            const form = $(this);

            const mainCheckbox = form.find('input[name="address[default]"]');

            const addressFieldVal = form.find('input[name="address[address1]"]').val();
            const addressTownFieldVal = form.find('input[name="address[city]"]').val();
            const addressPostCodeFieldVal = form.find('input[name="address[zip]"]').val();

            const firstNameFieldVal = form.find('input[name="address[first_name]"]').val();
            const lastNameFieldVal = form.find('input[name="address[last_name]"]').val();
            const phoneFieldVal = form.find('input[name="address[phone]"]').val();
            if ( mainCheckbox.prop("checked") ) {
                let addressFormData = {
                    "contacts": [
                        {
                            "channels": [
                                {
                                    "type": "email",
                                    "value": `${emailFieldVal}`
                                }
                            ],
                            "address": {
                                "town": `${addressTownFieldVal}`,
                                "address": `${addressFieldVal}`,
                                "postcode": `${addressPostCodeFieldVal}`
                            },
                            "firstName": `${firstNameFieldVal}`,
                            "lastName": `${lastNameFieldVal}`
                        }
                    ],
                    "contactFields": [
                        "firstName",
                        "lastName",
                        "address",
                        "town",
                        "postcode"
                    ],
                    "dedupeOn": "email"
                }

                let formattedAddressFormData = JSON.stringify(addressFormData);
                console.log(formattedAddressFormData)
                localStorage.setItem('edit_user_info', formattedAddressFormData);
            }

        })
    }

    if ( /edit_user_info=success/.test(window.location.href) ) {
        const addressFormData = localStorage.getItem('edit_user_info');
        const addressFormSettings = {
            async: true,
            crossDomain: true,
            url: 'https://esputnik.com/api/v1/contacts',
            method: 'POST',
            headers: {
                accept: 'application/json; charset=UTF-8',
                'content-type': 'application/json',
                authorization: 'Basic YXJ0aXN0cHVzaG5ldEBnbWFpbC5jb206d2V0cjQ1R3J2amRoNTRlNQ=='
            },
            processData: false,
            data: addressFormData
        };

        $.ajax(addressFormSettings).done(function (response) {
            console.log(response);
        });
    }

    if ( $('.text_block-link a:not(.disabled)').length ) {
        $(document).on('click', '.text_block-link a:not(.disabled)', function (evt) {
            if ( $('.text_block-link a:not(.disabled)').attr('href') === 'https://artistpush.io/music-branding/' ) {

                eS('sendEvent', 'ProductPage', {
                    'ProductPage': {
                        'productKey': 'landing2',
                        'price': '2.00 $',
                        'isInStock': 1,
                    }});

            } else if (  $('.text_block-link a:not(.disabled)').attr('href') === 'https://artistpush.io/' ) {

                eS('sendEvent', 'ProductPage', {
                    'ProductPage': {
                        'productKey': 'landing1',
                        'price': '1.00 $',
                        'isInStock': 1,
                    }});

            }
        })
    }


})
let productRecommendationPopup = document.querySelector('.js-product-recommendation-popup');
if(productRecommendationPopup){
    let productRecommendationPopupOverflow = productRecommendationPopup.querySelector('.product-recommendation-popup-overflow');
    if(productRecommendationPopupOverflow){
        productRecommendationPopupOverflow.addEventListener('click',function (){
            productRecommendationPopup.classList.remove('open');
        });
    }
}